import React from "react";
import { useIntl } from "react-intl";
import { Divider, Grid } from "@mui/material";
import { Checkbox } from "Components";

const Supervisor = ({ value, setValue, subUserSelected }) => {
  const { messages } = useIntl();

  return (
    <Grid container justifyContent={"center"} mb="15px" direction={"column"} spacing={2}>
        <Grid ml='10px'>
          <Checkbox
            checked={value}
            value={value}
            label={subUserSelected ? messages["role_thisUsetsupervisor"] : messages["role_supervisor"]}
            onChange={(checked) => {
              setValue(checked);
            }}
          />
        </Grid>
        <Divider />
    </Grid>
  );
};

export default Supervisor;
